module.exports = __webpack_public_path__ + "static/media/miguel_spanish_us.2f06db6c.mp3";